<script>
	import {createEventDispatcher, onMount} from "svelte";
	import PeriodPicker from "../Common/PeriodPicker.svelte";
	import Dropdown from "../Common/Dropdown.svelte";
	import {External, M} from "../external";

	export let funnel = null,
		period = {
			label: M.ALL_TIME_FILTER,
			id: "all",
			from: null,
			to: null
		},
		withFunnels = true;

	const dispatch = createEventDispatcher();

	let hasFunnels = false;
	let funnels = [
		{
			id: null,
			name: M.THE_WHOLE_STORE
		},
		...External.Website.funnels
	];
	let activeFunnel = funnels[0];

	let onChange = () => {
		dispatch("change", {
			period: period,
			funnel: {
				id: activeFunnel.id,
				name: activeFunnel.name
			}
		});
	};

	let onPeriodChanged = (event) => {
		period = event.detail.period;
		onChange();
	};

	let onDropdownChanged = (event) => {
		activeFunnel = event.detail.selected;
		onChange();
	};

	onMount(async function () {
		hasFunnels = withFunnels && External.Website.getActiveSite().type === "WEBSITE" && External.Website.funnels && External.Website.funnels.length;
		if (hasFunnels && funnel) {
			activeFunnel = External.getById(External.Website.funnels, funnel);
		}
	});
</script>

<div class="mt-10-mobile flex align-center">
	<div class="f-left">
		<PeriodPicker period={period} on:change={onPeriodChanged}/>
	</div>
	{#if hasFunnels}
		<h4 class="ml-15 hide-mobile">{M.FOR}</h4>
		<Dropdown items={funnels} activeItem={activeFunnel} on:change={onDropdownChanged} class="ml-15"/>
	{/if}
</div>
